import { Layout, Menu, Popconfirm, Dropdown, Space, message, } from "antd";
import {
    BarsOutlined,
    DiffOutlined,
    EditOutlined,
    LogoutOutlined,
    TableOutlined,
    DownOutlined,
    FolderFilled,
    SwapOutlined,
    PictureOutlined,
    KeyOutlined,
    AppstoreAddOutlined
} from '@ant-design/icons'

import './index.scss'
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { useDispatch, useSelector } from "react-redux";
import { clearUserInfo, fetchUserInfo } from "@/store/modules/user"
import { useEffect, useMemo, useCallback } from "react";
import { usePermission } from '@/hooks/usePermission'

const { Header, Sider } = Layout

const langs = [
    {
        key: 1,
        language: 'zh',
        label: (
            <span>简体中文</span>
        ),
    },
    {
        key: 2,
        language: 'en',
        label: (
            <span>English</span>
        ),
    },
]

const SystemLayout = () => {

    const { t } = useTranslation();

    // 统一菜单配置 + 绑定权限 code（叶子）。父级不写 code，只要有子级通过则展示。
    const menuConfig = useMemo(()=>[
        {
            label: t('SideBarList.ProjectManageList.ProjectManage'),
            icon: <BarsOutlined />,
            children: [
                { label: t('SideBarList.ProjectManageList.ProjectUpload'), key: '/ProjectUpload', code: 'ProjectUpload' },
                { label: t('SideBarList.ProjectManageList.ProjectDisplay'), key: '/ProjectDisplay', code: 'ProjectDisplay' },
            ]
        },
        {
            label: t('SideBarList.ShowLocationList.ShowLocation'),
            icon: <DiffOutlined />,
            children: [
                { label: t('SideBarList.ShowLocationList.ShowLocationUpload'), key: '/ShowLocationUpload', code: 'ShowLocationUpload' },
                { label: t('SideBarList.ShowLocationList.ShowLocationDisplay'), key: '/ShowLocationDisplay', code: 'ShowLocationDisplay' },
                { label: t('SideBarList.ShowLocationList.MyShowLocationDisplay'), key: '/MyShowLocationDisplay', code: 'MyShowLocationDisplay' },
            ]
        },
        {
            label: t('SideBarList.CompanyManage'),
            icon: <EditOutlined />,
            children: [
                { label: t('SideBarList.CompanyUpload'), key: '/CompanyUpload', code: 'CompanyUpload' },
                { label: t('SideBarList.CompanyDisplay'), key: '/CompanyDisplay', code: 'CompanyDisplay' },
                { label: t('SideBarList.AccountManage'), key: '/AccountManage', code: 'AccountManage' },
                { label: '用户注册', key: '/UserRegister', code: 'UserRegister' },
            ]
        },
        {
            label: t('SideBarList.FormsList.Forms'),
            icon: <TableOutlined />,
            children: [
                { label: t('SideBarList.FormsList.ProjectDetailForms'), key: '/ProjectDetailForms', code: 'ProjectDetailForms' },
                { label: t('SideBarList.FormsList.HistoryFlyForms'), key: '/HistoryFlyForms', code: 'HistoryFlyForms' },
            ]
        },
        {
            label: '设计库管理',
            icon: <PictureOutlined />,
            children: [
                { label: t('SideBarList.BlenderResourceUpload'), key: '/BlenderResourceUpload', code: 'BlenderResourceUpload' },
                { label: t('SideBarList.BlenderResourceDisplay'), key: '/BlenderResourceDisplay', code: 'BlenderResourceDisplay' },
                { label: '完整舞步裁切迁移', key: '/DanceStepCutTransfer', code: 'DanceStepCutTransfer' },
            ]
        },
        {
            label: '软件许可证管理',
            icon: <KeyOutlined />,
            children: [
                { label: '许可证列表', key: '/LicenseList', code: 'LicenseList' },
                { label: '新增许可证', key: '/LicenseAdd', code: 'LicenseAdd' },
            ]
        },
        {
            label: '软件更新管理',
            icon: <AppstoreAddOutlined />,
            children: [
                { label: '上传新版本', key: '/SoftwareUpdateUpload', code: 'SoftwareUpdateUpload' },
                { label: '软件更新列表', key: '/SoftwareUpdateList', code: 'SoftwareUpdateList' },
            ]
        },
        { label: t('SideBarList.FileManage'), key: '/FileManage', icon: <FolderFilled />, code: 'FileManage' },
        { label: '日志查看', key: '/UserLogs', icon: <SwapOutlined />, code: 'UserLogs' },
    ], [t])


    const onClick = ({ key }) => {

        switch (key) {
            case "1":
                message.info("切换成中文");
                window.location.reload();
                break;
            case "2":
                message.info("Switch To English");
                window.location.reload();
                break;
            default:
                break;
        }
        const language = langs[key - 1].language
        localStorage.setItem('lan', language)
        i18n.changeLanguage(language);
    };

    const dispatch = useDispatch()

    // 触发个人用户信息action
    useEffect(() => {
        dispatch(fetchUserInfo())

    }, [dispatch])

    const name = useSelector(state => state.user.userInfo.username);
    // 不再根据 power（角色）区分菜单，完全走权限码

    const navigate = useNavigate()
    const onMenuClick = (route) => {
        const path = route.key
        navigate(path)
    }

    //反向高亮
    //获取当前路由
    const location = useLocation()
    const selectedKey = location.pathname

    //退出登录确认回调
    const onConfirm = () => {
        dispatch(clearUserInfo())
        navigate('/login')
    }

    const { has, loading } = usePermission();

    // 递归权限过滤
    const filterMenu = useCallback((cfg) => (cfg || []).map(item => {
        if (item.children) {
            const children = filterMenu(item.children)
            if (!children.length) return null
            return { ...item, children }
        }
        if (item.code) return has(item.code) ? item : null
        return item
    }).filter(Boolean), [has])

    const menuItemsFiltered = useMemo(() => loading ? [] : filterMenu(menuConfig), [loading, menuConfig, filterMenu])

    return (
        <Layout>
            <Header className="header">
                <div className="logo" />
                <div className="user-info">
                    <span className="user-name">{name}</span>
                    <span className="language">
                        <Dropdown
                            menu={{
                                items: langs,
                                onClick,
                            }}
                        >
                            <Space>
                                {t('SwitchLanguage')}
                                <DownOutlined />
                            </Space>
                        </Dropdown>
                    </span>
                    <span className="user-logout">
                        <Popconfirm
                            title="是否确认退出?"
                            okText="退出"
                            cancelText="取消"
                            onConfirm={onConfirm}>
                            <LogoutOutlined />退出
                        </Popconfirm>
                    </span>
                </div>
            </Header>
            <Layout>
                <Sider width={250} className="site-layout-background">
                    <Menu
                        mode="inline"
                        selectedKeys={[selectedKey]}
                        style={{ height: '100%', borderRight: 0 }}
                        items={menuItemsFiltered}
                        onClick={onMenuClick}
                    />
                    {(!loading && menuItemsFiltered.length===0) && <div style={{padding:16,color:'#999'}}>暂无可访问菜单</div>}
                </Sider>
                <Layout className="layout-content" style={{ padding: 20, flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* 二级路由的出口 */}
                    <div style={{ flex: 1, overflow: 'auto' }}>
                        <Outlet />
                    </div>
                </Layout>
            </Layout>
    </Layout >
    )
}

export default SystemLayout